import React from "react";
import "../assets/styles/HeroSection.css";
import logo from "../assets/images/logo.png";
import chatbot from "../assets/images/chatbot.png";
import phoneMockup from "../assets/images/phone-mockup.png";
import BgTechNetwork from "./common/BgTechNetwork";
import { useNavigate } from "react-router-dom";
import BotaoContato from "./common/BotaoContato";

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className="hero">
      <BgTechNetwork />         

      <header className="hero-header">
        <img src={logo} alt="Summertech AI" className="logo" />
      </header>

      <div className="hero-content">
        <div className="hero-text">
          <h1>Tecnologia com IA para transformar seu atendimento</h1>
          <p>
            Somos uma empresa de tecnologia que cria soluções inteligentes para problemas reais.
            Nosso produto já está ajudando empresas a multiplicar sua capacidade de atendimento.
            Este é só o começo.
          </p>
          <div className="hero-buttons">
            <BotaoContato className="btn-primary" text="Conheça nossa solução" />
          </div>
        </div>

        <div className="hero-visual">
          <img src={chatbot} alt="Chatbot Summertech" className="chatbot" />
          <img src={phoneMockup} alt="Mockup de Chat" className="phone" />
        </div>
      </div>
    </section>
  );
}
